module.exports = __webpack_public_path__ + "static/media/webapp_background_stage@2x.748590ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/webapp_background_stage/webapp_background_stage@2x.png
// module id = 222
// module chunks = 0